export enum ColorPreferences {
	Teal = 1,
	Purple = 2,
}
